/*
  Minutedrone, backlog t7 (06/10/2026).
  Champ « Numéro de TVA intracommunautaire (facultatif) » du panier (tiroir et page panier),
  rendu par snippets/minutedrone-tva-client.liquid.
  - Enregistre la saisie comme attribut de panier (POST cart/update.js, API Ajax de Shopify) ;
    Shopify recopie les attributs du panier dans la commande.
  - Le champ porte aussi name="attributes[...]" et form="cart-form" : le bouton « Payer » renvoie la valeur.
  - Contrôle de format indicatif seulement : n'empêche jamais le paiement et ne vérifie pas VIES.
  - Aucun effet sur la TVA facturée.
*/
(function () {
  'use strict';

  if (!('customElements' in window) || window.customElements.get('md-tva-client')) return;

  // États membres de l'UE (EL = Grèce) et XI (Irlande du Nord, biens) : 8 à 12 caractères après le code pays.
  // Exceptions : Roumanie (2 à 10 chiffres), XI des administrations (GD/HA + 3 chiffres).
  var PAYS_UE = 'AT|BE|BG|CY|CZ|DE|DK|EE|EL|ES|FI|FR|HR|HU|IE|IT|LT|LU|LV|MT|NL|PL|PT|RO|SE|SI|SK|XI';
  var MOTIF_UE = new RegExp('^((' + PAYS_UE + ')[0-9A-Z+*]{8,12}|RO[0-9]{2,10}|XI(GD|HA)[0-9]{3})$');
  // France : FR + clé de 2 caractères + SIREN (9 chiffres) = 13 caractères.
  var MOTIF_FR = /^FR[0-9A-Z]{2}[0-9]{9}$/;
  var DELAI_MS = 800;

  function normaliser(valeur) {
    return String(valeur || '').toUpperCase().replace(/[\s.\-\/]/g, '');
  }

  function formatPlausible(valeur) {
    if (!valeur) return true;
    if (valeur.slice(0, 2) === 'FR') return MOTIF_FR.test(valeur);
    return MOTIF_UE.test(valeur);
  }

  function urlMiseAJour() {
    var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return racine + 'cart/update.js';
  }

  class MdTvaClient extends HTMLElement {
    connectedCallback() {
      this.champ = this.querySelector('input');
      this.erreur = this.querySelector('[data-md-tva-erreur]');
      if (!this.champ || !this.dataset.cle) return;

      this.enregistre = normaliser(this.champ.value);
      this.minuterie = null;
      this.requete = null;
      this.surSaisie = this.surSaisie.bind(this);
      this.surFin = this.surFin.bind(this);

      this.champ.addEventListener('input', this.surSaisie);
      this.champ.addEventListener('change', this.surFin);
      this.champ.addEventListener('blur', this.surFin);

      if (this.enregistre) this.afficher(formatPlausible(this.enregistre));
    }

    disconnectedCallback() {
      if (!this.champ) return;
      clearTimeout(this.minuterie);
      this.champ.removeEventListener('input', this.surSaisie);
      this.champ.removeEventListener('change', this.surFin);
      this.champ.removeEventListener('blur', this.surFin);
    }

    surSaisie() {
      var self = this;
      clearTimeout(this.minuterie);
      // Pendant la frappe : on retire le message dès que le format redevient plausible, sans en afficher de nouveau.
      if (this.erreur && !this.erreur.hidden && formatPlausible(normaliser(this.champ.value))) this.afficher(true);
      this.minuterie = setTimeout(function () {
        self.valider(false);
      }, DELAI_MS);
    }

    surFin() {
      clearTimeout(this.minuterie);
      this.valider(true);
    }

    valider(finDeSaisie) {
      var valeur = normaliser(this.champ.value);
      if (finDeSaisie) {
        if (this.champ.value !== valeur) this.champ.value = valeur;
        this.afficher(formatPlausible(valeur));
      }
      // Valeur enregistrée même si le format semble faux : rien de ce que tape le client n'est perdu,
      // l'équipe vérifie le numéro avant de l'utiliser.
      if (valeur !== this.enregistre) this.enregistrer(valeur);
    }

    afficher(ok) {
      if (this.erreur) this.erreur.hidden = ok;
      this.champ.setAttribute('aria-invalid', ok ? 'false' : 'true');
    }

    enregistrer(valeur) {
      var self = this;
      var attributs = {};
      var controleur = window.AbortController ? new AbortController() : null;

      if (this.requete) this.requete.abort();
      this.requete = controleur;
      attributs[this.dataset.cle] = valeur;

      fetch(urlMiseAJour(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributs }),
        signal: controleur ? controleur.signal : undefined
      })
        .then(function (reponse) {
          if (reponse.ok) self.enregistre = valeur;
        })
        .catch(function () {
          // Hors ligne ou requête annulée : le formulaire du panier renverra la valeur au clic sur « Payer ».
        })
        .then(function () {
          if (self.requete === controleur) self.requete = null;
        });
    }
  }

  window.customElements.define('md-tva-client', MdTvaClient);
})();
